import { render, staticRenderFns } from "./YpoEvents.vue?vue&type=template&id=12365e72&scoped=true&"
import script from "./YpoEvents.vue?vue&type=script&lang=js&"
export * from "./YpoEvents.vue?vue&type=script&lang=js&"
import style0 from "./YpoEvents.vue?vue&type=style&index=0&id=12365e72&lang=scss&scoped=true&"
import style1 from "./YpoEvents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12365e72",
  null
  
)

export default component.exports